<template>
  <div
    class="relative flex"
    :class="{ 'bg-background-neutral-secondary z-10': !isDeparture }"
  >
    <div
      class="point border-situational-muted bg-background-neutral-secondary absolute left-2.5 z-10 h-3 w-3 rounded-full border"
    ></div>
    <div class="ml-10 min-w-16">
      <p
        class="text-text-neutral-primary text-base font-semibold"
      >
        {{ point.time }}
      </p>
      <p class="text-text-neutral-quaternary text-sm">
        {{ point.dayOfMonth }}, {{ point.dayOfWeek }}
      </p>
    </div>
    <div class="ml-4 text-sm">
      <p class="text-text-neutral-primary text-base font-semibold">
        {{ point.city }}
      </p>
      <p
        :class="
          isDifferentAirports
            ? 'text-text-warning-accent'
            : 'text-text-neutral-quaternary'
        "
      >
        {{ point.airportText }}, {{ point.airport }}
      </p>
      <p
        v-if="point.terminal"
        :class="
          !isDifferentAirports && isDifferentTerminals
            ? 'text-text-warning-accent'
            : 'text-text-neutral-quaternary'
        "
      >
        {{ t('terminal', { terminal: point.terminal }) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import type { MappedSegmentPoint } from '../../types';

  const props = defineProps<{
    isDeparture?: boolean;
    point: MappedSegmentPoint;
    dependentPoint: MappedSegmentPoint | null;
    sourcePage?: string;
    flightIdx?: number;
    segmentIdx?: number;
  }>();

  const { t } = useI18n();

  const isDifferentAirports = computed(() => {
    return props.dependentPoint
      ? props.point.airport !== props.dependentPoint.airport
      : false;
  });

  const isDifferentTerminals = computed(() => {
    return props.dependentPoint
      ? props.point.terminal !== props.dependentPoint.terminal
      : false;
  });

  const directionText = props.isDeparture ? 'departure' : 'arrival';
</script>

<style scoped>
  .point {
    border-width: 3px;
  }
</style>

<i18n src="../../config/locales.json"></i18n>
